<template>
  <div id="bucket-view">
    <div class="card grida">
      <div class="card-title">
        <span>对象数</span>
      </div>
      <div class="card-body">
        <span v-if="resData.objectCount">{{
          number(resData.objectCount)
        }}</span>
        <span v-else>0</span>
      </div>
    </div>
    <div class="card gridd">
      <div class="card-title">
        <span>存储容量</span>
      </div>
      <div class="card-body">
        <div class="in data">
          <div class="btn-type">数据容量</div>
          <span v-if="resData.storeSizeHum">{{
            `${resData.storeSizeHum}`
          }}</span>
          <span v-else>0.00KB</span>
        </div>
        <div class="out data">
          <div class="btn-type">存储使用量</div>
          <span v-if="resData.spaceConsumedHum">{{
            `${resData.spaceConsumedHum}`
          }}</span>
          <span v-else>0.00KB</span>
        </div>
        <!-- <span v-if="resData.storeSizeHum"
          >{{ `${resData.storeSizeHum}` }} /{{ `${resData.spaceConsumedHum}` }}
        </span> -->
        <!-- <span v-else>0.00KB</span> -->
      </div>
    </div>
    <div class="card gridc">
      <div class="card-title">
        <span>月流量</span>
        <el-select size="small" v-model="monthFlow" placeholder="请选择">
          <el-option label="本月" value="ThisMonth"></el-option>
          <el-option label="上月" value="LastMonth"></el-option>
        </el-select>
      </div>
      <div class="card-body">
        <div class="in">
          <div class="btn-type">写入</div>
          <span v-if="resData[`input${monthFlow}Hum`]">{{
            resData[`input${monthFlow}Hum`]
          }}</span>
          <span v-else>0.00KB</span>
        </div>
        <div class="out">
          <div class="btn-type">写出</div>
          <span v-if="resData[`output${monthFlow}Hum`]">{{
            resData[`output${monthFlow}Hum`]
          }}</span>
          <span v-else>0.00KB</span>
        </div>
      </div>
    </div>
    <div class="card gridb">
      <div class="card-title">
        <span>日流量</span>
        <el-select size="small" v-model="dayFlow" placeholder="请选择">
          <el-option label="今日" value="Today"></el-option>
          <el-option label="昨日" value="Yesterday"></el-option>
        </el-select>
      </div>
      <div class="card-body">
        <div class="in">
          <div class="btn-type">写入</div>
          <span v-if="resData[`input${dayFlow}Hum`]">{{
            resData[`input${dayFlow}Hum`]
          }}</span>
          <span v-else>0.00KB</span>
        </div>
        <div class="out">
          <div class="btn-type">写出</div>
          <span v-if="resData[`output${dayFlow}Hum`]">{{
            resData[`output${dayFlow}Hum`]
          }}</span>
          <span v-else>0.00KB</span>
        </div>
      </div>
    </div>
    <div class="card gride">
      <div class="card-title">
        <span>日请求数</span>
        <el-select size="small" v-model="dayRequst" placeholder="请选择">
          <el-option label="今日" value="Today"></el-option>
          <el-option label="昨日" value="Yesterday"></el-option>
        </el-select>
      </div>
      <div class="card-body">
        <div class="in">
          <div class="btn-type">PUT</div>
          <span v-if="resData[`put${dayRequst}`]">{{
            number(resData[`put${dayRequst}`])
          }}</span>
          <span v-else>0</span>
        </div>
        <div class="out">
          <div class="btn-type">GET</div>
          <span v-if="resData[`get${dayRequst}`]">{{
            number(resData[`get${dayRequst}`])
          }}</span>
          <span v-else>0</span>
        </div>
      </div>
    </div>
    <div class="card gridf">
      <div class="card-title">
        <span>月请求数</span>
        <el-select size="small" v-model="monthRequst" placeholder="请选择">
          <el-option label="本月" value="ThisMonth"></el-option>
          <el-option label="上月" value="LastMonth"></el-option>
        </el-select>
      </div>
      <div class="card-body">
        <div class="in">
          <div class="btn-type">PUT</div>
          <span v-if="resData[`put${monthRequst}`]">{{
            number(resData[`put${monthRequst}`])
          }}</span>
          <span v-else>0</span>
        </div>
        <div class="out">
          <div class="btn-type">GET</div>
          <span v-if="resData[`get${monthRequst}`]">{{
            number(resData[`get${monthRequst}`])
          }}</span>
          <span v-else>0</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bucket-view",
  props: {
    bucket: {
      type: Object
    }
  },
  data() {
    return {
      resData: {},
      monthFlow: "ThisMonth",
      dayFlow: "Today",
      monthRequst: "ThisMonth",
      dayRequst: "Today"
    };
  },
  watch: {
    bucket: {
      immediate: true,
      handler(v) {
        if (v) {
          this.getData();
        }
      }
    }
  },
  methods: {
    getData() {
      this.$http
        .get("/gavial/v1/mos/bucket/summary?bucket=" + this.bucket.name)
        .then(res => {
          this.resData = res.data.data;
        });
    },
    number(data) {
      if (data !== null) {
        return data.toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
      }
      return "0";
    }
  }
};
</script>

<style lang="scss" scoped>
.grida {
  grid-area: grida;
}
.gridb {
  grid-area: gridb;
}
.gridc {
  grid-area: gridc;
}
.gridd {
  grid-area: gridd;
}
.gride {
  grid-area: gride;
}
.gridf {
  grid-area: gridf;
}

#bucket-view {
  height: 100%;
  overflow: hidden;
  display: grid;
  grid-template-columns: repeat(3, 1fr [col-start]);
  grid-template-rows: repeat(2, 1fr [row-start]);
  grid-template-areas:
    "grida gridb gridc"
    "gridd gride gridf";
}
.grida,
.gridd {
  border-left: 1px solid #eee;
}
.card {
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.card-title {
  height: 40px;
  padding: var(--padding);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-title span {
  font-size: 20px;
  color: #929292;
}
.btn-type {
  display: flex;
  align-items: center;
  padding: 0 40px;
  border-radius: 4px;
  white-space: nowrap;
}
.card-title .el-select {
  flex: 0 0 120px;
}
.card-body {
  height: calc(100% - 120px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.card-body span {
  font-size: 40px;
  color: rgb(124, 161, 240);
}

.card-body .data .btn-type {
  padding: 0 20px;
}
.card-body .in,
.card-body .out {
  display: flex;
  width: 95%;
  justify-content: space-between;
}
.card-body .out {
  margin-top: 10px;
}
</style>
